(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5682],{

/***/ 11641:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiles/bathroom-tiles/[...subCategory]",
      function () {
        return __webpack_require__(53281);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ component; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_components_sub_category__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39489);


var __N_SSP = true;
function component(props) {
    if (props.error) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: JSON.stringify(props.error)
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_sub_category__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...props.oldComponentProps
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7312,5518,4585,7615,6212,6737,7528,7933,3372,7349,166,9489,9774,2888,179], function() { return __webpack_exec__(11641); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);